import { Component, Input } from "@angular/core";
import { SubmitProposalStep } from "@app/features/submit-proposal/services/submit-proposal-state.service";
import { SubmitProposalLeftComponent } from "../submit-proposal-left/submit-proposal-left.component";
import { SubmitProposalRightComponent } from "../submit-proposal-right/submit-proposal-right.component";

@Component({
  selector: "pa-submit-proposal-content",
  templateUrl: "./submit-proposal-content.component.html",
  styleUrls: ["./submit-proposal-content.component.scss"],
  imports: [SubmitProposalLeftComponent, SubmitProposalRightComponent],
})
export class SubmitProposalContentComponent {
  @Input() step!: SubmitProposalStep;

  public studentExplanation = "";
  public submitBtnDisabled = false;
}
